import React from "react";

const ErrorPage = () => {
  return (
    <div style={{ padding: "10rem", textAlign: "center", background: "#fff" }}>
      <i className="fa fa-frown-o" style={{ fontSize: "10rem", color: "#000" }} />
      <h1 style={{
        fontFamily: "Oswald",
        fontSize: "3rem",
        fontWeight: 300,
        paddingTop: "4.5rem",
        margin: 0,
      }}>
        Sorry, that page can’t be found
      </h1>
      <p style={{
        fontFamily: "Sintony",
        fontSize: "1.5rem",
        color: "#7D7D7D",
        lineHeight: 1.7,
      }}>
        It looks like that page isn’t here. Try{" "}
        <a href="/search" style={{ color: "#1285c0", textDecoration: "none" }}>
          starting a search
        </a>.
      </p>
    </div>
  );
};
export default ErrorPage